<template>
    <div class="img-bg">
        <div class="preview">
            <img class="fullimg" :src=viewimg />
        </div>
        <n-divider />
        <div class="listedimg">
            <!-- <div class="imglist" v-for="img in imglist"> -->
            <div class="imglist" v-for="(item, index) in imglist" :key="index">
                <img @click="imagepreview(imglist[index])" class="fulllistedimg" :src="imglist[index]">
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from 'vue'

export default defineComponent({
    props: {

        PorpsImageList: {
            type: Object,
        }
    },
    setup(props) {
        const imglist: any = [
            // {
            //     url: 'https://www.iddo.org/sites/default/files/styles/slideshow/public/slideshow/2018-04/pexels-photo-415825_blue%20white%20pills.jpg?h=c5515ee6&itok=-tfLiODB'
            // },
            // {
            //     url: 'https://medlineplus.gov/images/Medicines.jpg'
            // },
            // {
            //     url: 'https://www.iddo.org/sites/default/files/styles/slideshow/public/slideshow/2018-04/pexels-photo-415825_blue%20white%20pills.jpg?h=c5515ee6&itok=-tfLiODB'
            // },
            // {
            //     url: 'https://medlineplus.gov/images/Medicines.jpg'
            // },
        ]
        let imgpreview = ref('')
        watch(
            () => props.PorpsImageList,
            (newVal) => {
                debugger;
                if (props.PorpsImageList) {
                    Object.values(props.PorpsImageList).forEach(value => {
                        imglist.push(value);
                    });
                    imgpreview.value = imglist[0];
                }
            },
            { deep: true }
        );

        return {
            imagepreview(imgdata) {
                imgpreview.value = imgdata
            },
            imglist,
            viewimg: imgpreview,

        }
    }

})
</script>

<style lang="scss">
.preview {
    height: 200px;
    width: 100%;
    background-color: gray;

    .fullimg {
        width: 100%;
        height: 100%;
    }
}

.listedimg {
    display: -webkit-box;
    width: 100%;
    overflow: auto;

    .imglist {
        height: 45px;
        width: 45px;
        margin: 10px;

        .fulllistedimg {
            height: 40px;
            width: 40px;
        }
    }
}

.n-divider:not(.n-divider--vertical) {
    margin-top: 14px;
    margin-bottom: 1px;
}

.imglist:hover {
    border-bottom: 2px solid #000000;
}

.img-bg {
    background-color: #FFFFFF;
}
</style>